import React, {useEffect} from 'react';
import {Drawer as MuiDrawer, DrawerProps} from '@mui/material';
import {useLocation} from 'react-router-dom';
import classNames from 'classnames';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faXmark} from '@fortawesome/pro-solid-svg-icons';

import MediaQuery from 'shared/media-query';

import UnstyledButton from '../unstyled-button';
import NavbarLink from './NavbarLink/NavbarLink';
import MobileNavbarMenuList from './MobileNavbarMenuList';
import {NavbarButtonProps} from './NavbarButton';
import {CTAButtonProps} from './NavbarCTAButton';
import {NavbarMenuProps} from './NavbarMenu/NavbarMenu';

import styles from './styles.module.scss';

interface Props {
  menus: (NavbarMenuProps | NavbarButtonProps)[];
  ctaButtons?: CTAButtonProps[];
  routed?: boolean;
  avatarMenuItems?: NavbarButtonProps[];
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  experienceEverywhere?: boolean;
}

const NavbarDrawer = ({
  menus,
  routed,
  ctaButtons,
  avatarMenuItems,
  setOpen,
  experienceEverywhere,
  ...drawerProps
}: Props & DrawerProps) => {
  const location = useLocation();

  // Close drawer after user navigates
  useEffect(() => {
    setOpen(false);
  }, [setOpen, location]);

  return (
    <MuiDrawer
      variant={experienceEverywhere ? 'temporary' : 'persistent'}
      classes={{
        paper: classNames(styles.drawer, {
          [styles.experienceEverywhereDrawer]: experienceEverywhere,
        }),
      }}
      onClose={() => setOpen(false)}
      {...drawerProps}
    >
      {!experienceEverywhere && (
        <div className={styles.backdrop} onClick={() => setOpen(false)}></div>
      )}
      {experienceEverywhere && (
        <UnstyledButton className={styles.closeIconButton} onClick={() => setOpen(false)}>
          <FontAwesomeIcon icon={faXmark} />
        </UnstyledButton>
      )}
      <MobileNavbarMenuList
        menus={menus}
        routed={routed}
        experienceEverywhere={experienceEverywhere}
      />
      <MediaQuery.SM_AND_DOWN>
        {ctaButtons?.map((button) => (
          <NavbarLink
            key={button.title}
            to={button.path}
            routed={button.routed}
            title={button.title}
            className={styles.drawerLink}
          />
        ))}
        {avatarMenuItems?.map((item) => (
          <NavbarLink
            key={item.title}
            to={item.path}
            routed={item.routed}
            title={item.title}
            className={styles.drawerLink}
          />
        ))}
      </MediaQuery.SM_AND_DOWN>
    </MuiDrawer>
  );
};

export default NavbarDrawer;
